import { useQuery } from "@tanstack/react-query";
import { clientKPIService, type ClientKPIData } from "@/services/clientKPIService";

export const useClientKPIs = (clientIds: string[]) => {
  return useQuery({
    queryKey: ["client-kpis", clientIds],
    queryFn: () => clientKPIService.getClientKPIs(clientIds),
    staleTime: 5 * 60 * 1000, // 5 minutes
    enabled: clientIds.length > 0,
  });
};